import dxDataGrid from 'devextreme/ui/data_grid';

/**
 * Adds a state store reset button if statestoring is enabled
 * This module is adding the toolbar button the same way as DX adds a column chooser button
 * For example implementation:
 *  - File: node_modules/devextreme/ui/grid_core/ui.grid_core.column_chooser.js
 *  - Search for '_appendColumnChooserItem'
 */
export function registerStateStoreResetButtonModule() {
	(<any>dxDataGrid).registerModule('stateStoreResetButton', {
		extenders: {
			views: {
				headerPanel: {
					_getToolbarItems: function () {
						const items = this.callBase();
						return this._appendStateStoreResetButtonItem(items);
					},
					_appendStateStoreResetButtonItem: function (items) {
						// Add button if state storing is enabled
						const stateStoringEnabled = this.option('stateStoring.enabled');
						if (stateStoringEnabled) {
							const onClickHandler = () => {
								this.component.state({});
								this.component.option('searchPanel.text', ''); // Not sure why it doesn't clear now, so clear it manually.
								this.component.option('selectedRowKeys', []); // Not sure why this is not cleared automatically, so we do it manually
							};
							const toolbarItem = {
								widget: 'dxButton',
								options: {
									icon: 'far fa-exclamation-triangle',
									onClick: onClickHandler,
									hint: 'Reset layout',
									text: 'Reset layout'
								},
								showText: 'inMenu',
								location: 'after',
								name: 'reset-button', // name has to be in DEFAULT_TOOLBAR_ITEM_NAMES, or devextreme will cause a crash...
								locateInMenu: 'auto',
								sortIndex: 40,
							};

							items.push(toolbarItem);
						}
						return items;
					},
					_normalizeToolbarItems(defaultItems, userItems) {
						const rb = defaultItems.find(di => di.name === 'reset-button');
						defaultItems = defaultItems.filter(di => di.name !== 'reset-button');
						const items = this.callBase(defaultItems, userItems);

						if(rb) {
							// Keep searchpanel most right
							const buttonIndex =
							items.length > 0 && items[items.length - 1].name === 'searchPanel' ? items.length - 1 : items.length;

							// Add the reset button
							items.splice(buttonIndex, 0, rb);
						}
						return items;
					},
					optionChanged: function (args) {
						switch (args.name) {
							// Invalidate the headerpanel if this option gets changed (this will repaint the panel!)
							case 'stateStoring':
								this._invalidate();
								args.handled = true;
								break;
							default:
								this.callBase(args);
						}
					},
					isVisible: function () {
						const that = this;
						const stateStoringEnabled = that.option('stateStoring.enabled');
						return that.callBase() || stateStoringEnabled;
					},
				},
			},
		},
	});
}
